import { getBoards } from "@/lib/api";
import { resolvePostLoginTarget } from "@/lib/post-login-redirect";

export type AuthLandingTarget =
  | { to: "/dashboard" }
  | { to: "/display/$slug"; params: { slug: string } };

/**
 * Choisit la destination par defaut pour un utilisateur deja authentifie.
 * Si une preference valide existe, ouvre la vue display du board cible.
 */
export async function resolveAuthenticatedLandingTarget(
  preferredBoardId: string | null | undefined,
): Promise<AuthLandingTarget> {
  const preferred = (preferredBoardId ?? "").trim();
  if (!preferred) {
    return { to: "/dashboard" };
  }

  const boardsResult = await getBoards();
  if (!boardsResult.ok) {
    return { to: "/dashboard" };
  }

  const target = resolvePostLoginTarget({
    explicitRedirect: null,
    preferredBoardId: preferred,
    boards: boardsResult.data.boards.map((board) => ({ id: board.id, slug: board.slug })),
  });

  if (target.kind === "display") {
    return { to: "/display/$slug", params: { slug: target.slug } };
  }

  return { to: "/dashboard" };
}